import { Close } from '@mui/icons-material'
import { Button, IconButton, OutlinedInput, Typography } from '@mui/material'
import React from 'react'
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { toast } from "react-toastify";
import { useForm } from 'react-hook-form';
import { useCreateRoleMutation } from '../../Store/Services/RoleService';
import styles from "./Roles.module.css";


const schema = yup.object({
    brName:yup.string().required(""),
}).required();

const AddRole = ({ handleClose }) => {

    const {register, handleSubmit, formState: { errors }} = useForm({
        resolver: yupResolver(schema),
    });

    const [createRole] = useCreateRoleMutation();

    const onSubmit = async (data) => {
        try {
            const respond = await createRole(data).unwrap();
            // toast.success("Role successfully added!");
        } catch (err) {
            console.error("Failed to save the Role: ", err);
            toast.error("Erorr, something went wrong!");
        }
        handleClose();
    };

    return (
        <div>
            <div className={styles.headingContainer}>
                <Typography fontWeight={600} variant={"h6"}>
                    Add Role
                </Typography>
                <IconButton className={styles.closeButton} onClick={handleClose} aria-label="Close">
                    <Close />
                </IconButton>
            </div>

            <form onSubmit={handleSubmit(onSubmit)}>
                <div className={styles.formItem}>
                    <label className={styles.formLabel}>Name:</label>
                    {errors.brName && errors.brName.type === "required" && <span className={styles.validation} > *</span>}
                    <OutlinedInput
                        {...register("brName")}
                        className={styles.formInput}
                        placeholder="Enter Name"
                        size="small"
                        fullWidth
                    />
                </div>

                {/* Submit Button */}
                <div className={styles.buttonContainer}>
                    <Button type="submit" className={styles.submitButton} variant="contained" aria-label="Save">Save</Button>
                </div>
            </form>
        </div>
    )
}

export default AddRole